<template>
  <div>
    <div class="py-1 t3m-Swiper t3m-Swiper--flx">
      <swiper
        class="swiper-flx "
        :space-between="8"
        navigation
        pagination
        :breakpoints="swiperBreakpoints"
        :preloadImages="false"
        :lazy="true"
        :watchSlidesVisibility="true"
        @slideChange="onSlideChange"
      >
        <swiper-slide v-if="introduction">
          <card-blank :html-content="introduction" />
        </swiper-slide>
        <swiper-slide
          v-for="(s, indx) in slides"
          :key="indx"
          v-slot="{ isActive }"
        >
          <card
            v-bind="s"
            :connectToBillboard="connectToBillboard"
            :isKeyFact="keyFacts && !s.isCurrentPage"
            :isActive="isActive"
            :contentType="contentType"
            :myIndex="indx"
            :size="size"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SwiperCore, { Navigation, Pagination, Lazy } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import Card from "@/components/Card/Card.vue";
import CardBlank from "@/components/Card/CardBlank.vue";

SwiperCore.use([Navigation, Pagination, Lazy]);

export default {
  name: "Carousel",
  components: {
    Card,
    CardBlank,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {};
  },
  props: {
    slides: Object,
    connectToBillboard: Boolean,
    keyFacts: Boolean,
    contentType: String,
    size: String,
    introduction: String,
  },
  mounted() {},
  computed: {
    ...mapState(["selectedCard"]),

    swiperBreakpoints: function () {
      return {
        0: {
          slidesPerView: (this.size === "auto" && this.contentType != 'theme_flxmenu') ? 1 : 2,
        },
        640: {
          slidesPerView: this.size === "auto" ? 2 : 2,
        },
        768: {
          slidesPerView: this.size === "auto" ? 2 : 2,
        },
        992: {
          slidesPerView: this.size === "auto" ? 3 : 3,
        },
        1200: {
          slidesPerView: this.size === "auto" ? 3 : 4,
        },
        1500: {
          slidesPerView: this.size === "auto" ? 4 : 4,
        },
        1920: {
          slidesPerView: this.size === "auto" ? 5 : 5,
        },
      };
    },
  },
  methods: {
    ...mapActions(["selectCard"]),
    onSlideChange() {
      this.selectCard(undefined);
    },
  },
};
</script>
